export const mockDoctors = [
  {
    id: 1,
    name: "Dr. Sarah Johnson",
    specialties: ["Cardiologist"],
    email: "sarah@medihub.com",
    phone: "+1-555-0101",
    status: "active",
    verified: true,
    experience: 12,
    rating: 4.8,
    patients: 245,
    fees: 150,
    avatar: null,
    availableSlots: [
      "09:00 AM",
      "10:00 AM",
      "11:00 AM",
      "02:00 PM",
      "04:00 PM",
    ],
    commissionType: 'percentage',
    commissionValue: 10,
    walletBalance: 1200.0,
    totalEarnings: 1800.0,
    totalCommission: 200.0,
    totalWithdrawn: 600.0,
    earningsHistory: [
      { id: "APT-001", appointmentId: 1, patient: "John Smith", doctorFee: 150, commission: 15, doctorEarning: 135, date: "2024-12-10" },
      { id: "APT-005", appointmentId: 5, patient: "William Anderson", doctorFee: 150, commission: 15, doctorEarning: 135, date: "2024-12-08" },
      { id: "APT-009", appointmentId: 9, patient: "Emma Wilson", doctorFee: 150, commission: 15, doctorEarning: 135, date: "2024-12-01" },
      { id: "APT-012", appointmentId: 12, patient: "James Brown", doctorFee: 150, commission: 15, doctorEarning: 135, date: "2024-11-25" },
    ],
    withdrawRequests: [
      {
        id: "WR-001",
        amount: 300,
        status: "approved",
        date: "2024-12-05",
        processedDate: "2024-12-06",
      },
      {
        id: "WR-002",
        amount: 300,
        status: "pending",
        date: "2024-11-20",
        processedDate: "2024-11-21",
      },
      {
        id: "WR-003",
        amount: 400,
        status: "rejected",
        date: "2025-11-20",
        processedDate: "2025-12-21",
      },
    ],
  },
  {
    id: 2,
    name: "Dr. Michael Chen",
    specialties: ["Neurologist", "General Physician"],
    email: "michael@medihub.com",
    phone: "+1-555-0102",
    status: "active",
    verified: true,
    experience: 8,
    rating: 4.6,
    patients: 189,
    fees: 120,
    avatar: null,
    availableSlots: ["10:00 AM", "01:00 PM", "03:00 PM"],
    commissionType: 'fixed',
    commissionValue: 20,
    walletBalance: 840.0,
    totalEarnings: 1080.0,
    totalCommission: 60.0,
    totalWithdrawn: 240.0,
    earningsHistory: [
      { id: "APT-002", appointmentId: 2, patient: "Emma Wilson", doctorFee: 120, commission: 20, doctorEarning: 100, date: "2024-12-18" },
      { id: "APT-006", appointmentId: 6, patient: "John Smith", doctorFee: 120, commission: 20, doctorEarning: 100, date: "2024-12-10" },
      { id: "APT-010", appointmentId: 10, patient: "Olivia Taylor", doctorFee: 120, commission: 20, doctorEarning: 100, date: "2024-12-02" },
    ],
    withdrawRequests: [
      {
        id: "WR-003",
        amount: 240,
        status: "approved",
        date: "2024-12-01",
        processedDate: "2024-12-02",
      },
      {
        id: "WR-004",
        amount: 200,
        status: "pending",
        date: "2024-12-19",
        processedDate: null,
      },
    ],
  },
  {
    id: 3,
    name: "Dr. Emily Davis",
    specialties: ["Pediatrician"],
    email: "emily@medihub.com",
    phone: "+1-555-0103",
    status: "inactive",
    verified: false,
    experience: 5,
    rating: 4.9,
    patients: 312,
    fees: 100,
    avatar: null,
    availableSlots: ["09:00 AM", "11:00 AM", "02:00 PM"],
    commissionType: 'percentage',
    commissionValue: 8,
    walletBalance: 300.0,
    totalEarnings: 300.0,
    totalCommission: 24.0,
    totalWithdrawn: 0,
    earningsHistory: [
      { id: "APT-003", appointmentId: 3, patient: "James Brown", doctorFee: 100, commission: 8, doctorEarning: 92, date: "2024-12-15" },
      { id: "APT-007", appointmentId: 7, patient: "John Smith", doctorFee: 100, commission: 8, doctorEarning: 92, date: "2024-12-08" },
      { id: "APT-011", appointmentId: 11, patient: "Emma Wilson", doctorFee: 100, commission: 8, doctorEarning: 92, date: "2024-11-30" },
    ],
    withdrawRequests: [],
  },
  {
    id: 4,
    name: "Dr. Robert Wilson",
    specialties: ["Orthopedic", "General Physician"],
    email: "robert@medihub.com",
    phone: "+1-555-0104",
    status: "active",
    verified: true,
    experience: 15,
    rating: 4.7,
    patients: 198,
    fees: 180,
    avatar: null,
    availableSlots: ["08:00 AM", "10:00 AM", "12:00 PM", "03:00 PM"],
    commissionType: 'fixed',
    commissionValue: 30,
    walletBalance: 540.0,
    totalEarnings: 900.0,
    totalCommission: 90.0,
    totalWithdrawn: 360.0,
    earningsHistory: [
      { id: "APT-004", appointmentId: 4, patient: "Olivia Taylor", doctorFee: 180, commission: 30, doctorEarning: 150, date: "2024-12-12" },
      { id: "APT-008", appointmentId: 8, patient: "William Anderson", doctorFee: 180, commission: 30, doctorEarning: 150, date: "2024-12-05" },
      { id: "APT-013", appointmentId: 13, patient: "James Brown", doctorFee: 180, commission: 30, doctorEarning: 150, date: "2024-11-28" },
    ],
    withdrawRequests: [
      {
        id: "WR-005",
        amount: 360,
        status: "approved",
        date: "2024-11-30",
        processedDate: "2024-12-01",
      },
      {
        id: "WR-006",
        amount: 150,
        status: "rejected",
        date: "2024-12-10",
        processedDate: null,
      },
    ],
  },
  {
    id: 5,
    name: "Dr. Lisa Martinez",
    specialties: ["Dermatologist"],
    email: "lisa@medihub.com",
    phone: "+1-555-0105",
    status: "pending",
    verified: false,
    experience: 6,
    rating: 4.5,
    patients: 156,
    fees: 110,
    avatar: null,
    availableSlots: ["11:00 AM", "02:00 PM", "05:00 PM"],
    commissionType: 'percentage',
    commissionValue: 12,
    walletBalance: 220.0,
    totalEarnings: 220.0,
    totalCommission: 26.4,
    totalWithdrawn: 0,
    earningsHistory: [
      { id: "APT-014", appointmentId: 14, patient: "Emma Wilson", doctorFee: 110, commission: 13.2, doctorEarning: 96.8, date: "2024-12-18" },
      { id: "APT-015", appointmentId: 15, patient: "John Smith", doctorFee: 110, commission: 13.2, doctorEarning: 96.8, date: "2024-12-10" },
    ],
    withdrawRequests: [
      {
        id: "WR-007",
        amount: 100,
        status: "pending",
        date: "2024-12-20",
        processedDate: null,
      },
    ],
  },
];

export const mockPatients = [
  { id: 1, name: 'John Smith', email: 'john@email.com', phone: '+1-555-1001', age: 34, gender: 'Male', status: 'active', joinDate: '2024-01-15', appointments: 5, lastVisit: '2024-12-10', address: '123 Main St, New York, NY',
    totalSpent: 420.00, totalDeposited: 0, walletBalance: 0,
    transactions: [
      { id: 'TXN-P001', type: 'Appointment', amount: 150, method: 'Credit Card', status: 'completed', date: '2024-12-10', reference: 'REF-ABC123', appointmentId: 1 },
      { id: 'TXN-P002', type: 'Medicine Order', amount: 21.23, method: 'Credit Card', status: 'completed', date: '2024-12-10', reference: 'REF-ABC124', orderId: 'ORD-001' },
      { id: 'TXN-P003', type: 'Appointment', amount: 120, method: 'PayPal', status: 'completed', date: '2024-12-05', reference: 'REF-DEF456', appointmentId: 6 },
      { id: 'TXN-P004', type: 'Appointment', amount: 110, method: 'Debit Card', status: 'pending', date: '2024-12-20', reference: 'REF-PEN001', appointmentId: 7 },
      { id: 'TXN-P005', type: 'Medicine Order', amount: 18.77, method: 'UPI', status: 'failed', date: '2024-12-18', reference: 'REF-FAIL01', orderId: null },
    ],
  },
  { id: 2, name: 'Emma Wilson', email: 'emma@email.com', phone: '+1-555-1002', age: 28, gender: 'Female', status: 'active', joinDate: '2024-02-20', appointments: 3, lastVisit: '2024-12-05', address: '456 Oak Ave, Los Angeles, CA',
    totalSpent: 242.50, totalDeposited: 0, walletBalance: 0,
    transactions: [
      { id: 'TXN-P006', type: 'Appointment', amount: 120, method: 'Credit Card', status: 'completed', date: '2024-12-18', reference: 'REF-EMM001', appointmentId: 2 },
      { id: 'TXN-P007', type: 'Medicine Order', amount: 12.50, method: 'PayPal', status: 'completed', date: '2024-12-18', reference: 'REF-EMM002', orderId: 'ORD-002' },
      { id: 'TXN-P008', type: 'Appointment', amount: 110, method: 'UPI', status: 'completed', date: '2024-12-15', reference: 'REF-EMM003', appointmentId: 7 },
    ],
  },
  { id: 3, name: 'James Brown', email: 'james@email.com', phone: '+1-555-1003', age: 52, gender: 'Male', status: 'suspended', joinDate: '2023-11-10', appointments: 8, lastVisit: '2024-11-20', address: '789 Pine Rd, Houston, TX',
    totalSpent: 200.00, totalDeposited: 0, walletBalance: 0,
    transactions: [
      { id: 'TXN-P009', type: 'Appointment', amount: 100, method: 'Debit Card', status: 'completed', date: '2024-12-15', reference: 'REF-JAM001', appointmentId: 3 },
      { id: 'TXN-P010', type: 'Appointment', amount: 120, method: 'Credit Card', status: 'refunded', date: '2024-12-19', reference: 'REF-JAM002', appointmentId: null },
      { id: 'TXN-P011', type: 'Medicine Order', amount: 18.50, method: 'UPI', status: 'refunded', date: '2024-12-20', reference: 'REF-JAM003', orderId: 'ORD-005' },
    ],
  },
  { id: 4, name: 'Olivia Taylor', email: 'olivia@email.com', phone: '+1-555-1004', age: 41, gender: 'Female', status: 'active', joinDate: '2024-03-05', appointments: 2, lastVisit: '2024-12-12', address: '321 Elm St, Miami, FL',
    totalSpent: 206.25, totalDeposited: 0, walletBalance: 0,
    transactions: [
      { id: 'TXN-P012', type: 'Appointment', amount: 180, method: 'Credit Card', status: 'completed', date: '2024-12-12', reference: 'REF-OLI001', appointmentId: 4 },
      { id: 'TXN-P013', type: 'Medicine Order', amount: 26.25, method: 'PayPal', status: 'completed', date: '2024-12-19', reference: 'REF-OLI002', orderId: 'ORD-003' },
    ],
  },
  { id: 5, name: 'William Anderson', email: 'william@email.com', phone: '+1-555-1005', age: 67, gender: 'Male', status: 'active', joinDate: '2023-09-18', appointments: 12, lastVisit: '2024-12-08', address: '654 Maple Dr, Seattle, WA',
    totalSpent: 150.00, totalDeposited: 0, walletBalance: 0,
    transactions: [
      { id: 'TXN-P014', type: 'Appointment', amount: 150, method: 'Debit Card', status: 'completed', date: '2024-12-08', reference: 'REF-WIL001', appointmentId: 5 },
      { id: 'TXN-P015', type: 'Appointment', amount: 100, method: 'Credit Card', status: 'failed', date: '2024-12-20', reference: 'REF-WIL002', appointmentId: null },
    ],
  },
];

const today = new Date().toISOString().split('T')[0];
const tomorrow = new Date(Date.now() + 86400000).toISOString().split('T')[0];
const yesterday = new Date(Date.now() - 86400000).toISOString().split('T')[0];
const nextWeek = new Date(Date.now() + 7 * 86400000).toISOString().split('T')[0];

export const mockAppointments = [
  { id: 1, patientId: 1, patient: 'John Smith', doctorId: 1, doctor: 'Dr. Sarah Johnson', date: today, time: '10:00 AM', type: 'Consultation', status: 'scheduled', fee: 150, notes: 'Chest pain follow-up' },
  { id: 2, patientId: 2, patient: 'Emma Wilson', doctorId: 2, doctor: 'Dr. Michael Chen', date: tomorrow, time: '2:30 PM', type: 'Follow-up', status: 'scheduled', fee: 120, notes: 'Migraine treatment review' },
  { id: 3, patientId: 3, patient: 'James Brown', doctorId: 3, doctor: 'Dr. Emily Davis', date: yesterday, time: '11:00 AM', type: 'Check-up', status: 'completed', fee: 100, notes: 'Routine check-up' },
  { id: 4, patientId: 4, patient: 'Olivia Taylor', doctorId: 4, doctor: 'Dr. Robert Wilson', date: nextWeek, time: '9:00 AM', type: 'Consultation', status: 'cancelled', fee: 180, notes: 'Knee pain assessment' },
  { id: 5, patientId: 5, patient: 'William Anderson', doctorId: 1, doctor: 'Dr. Sarah Johnson', date: nextWeek, time: '3:00 PM', type: 'Follow-up', status: 'scheduled', fee: 150, notes: 'Blood pressure monitoring' },
  { id: 6, patientId: 1, patient: 'John Smith', doctorId: 2, doctor: 'Dr. Michael Chen', date: yesterday, time: '9:00 AM', type: 'Consultation', status: 'completed', fee: 120, notes: 'Headache evaluation' },
  { id: 7, patientId: 2, patient: 'Emma Wilson', doctorId: 5, doctor: 'Dr. Lisa Martinez', date: today, time: '4:00 PM', type: 'Check-up', status: 'scheduled', fee: 110, notes: 'Skin rash examination' },
];

export const mockPrescriptions = [
  { id: 1, appointmentId: 3, patientId: 3, doctorId: 3, patient: 'James Brown', doctor: 'Dr. Emily Davis', date: yesterday, medicines: ['Paracetamol 500mg', 'Vitamin C'], notes: 'Take after meals', fileType: 'pdf', fileName: 'prescription_003.pdf' },
  { id: 2, appointmentId: 6, patientId: 1, doctorId: 2, patient: 'John Smith', doctor: 'Dr. Michael Chen', date: yesterday, medicines: ['Ibuprofen 400mg', 'Omeprazole 20mg'], notes: 'Avoid alcohol', fileType: 'image', fileName: 'prescription_006.jpg' },
];

export const mockMedicalReports = [
  { id: 1, patientId: 1, title: 'Blood Test Report', date: '2024-11-15', type: 'pdf', fileName: 'blood_test_john.pdf', doctor: 'Dr. Sarah Johnson' },
  { id: 2, patientId: 1, title: 'ECG Report', date: '2024-12-01', type: 'image', fileName: 'ecg_john.jpg', doctor: 'Dr. Sarah Johnson' },
  { id: 3, patientId: 2, title: 'MRI Scan', date: '2024-11-20', type: 'pdf', fileName: 'mri_emma.pdf', doctor: 'Dr. Michael Chen' },
  { id: 4, patientId: 5, title: 'X-Ray Report', date: '2024-10-10', type: 'image', fileName: 'xray_william.jpg', doctor: 'Dr. Robert Wilson' },
];

export const mockMedicines = [
  { id: 1, name: 'Paracetamol 500mg', category: 'Analgesic', price: 5.99, stock: 500, unit: 'tablets', manufacturer: 'PharmaCo', expiry: '2026-06-30', status: 'in-stock', prescriptionRequired: false },
  { id: 2, name: 'Amoxicillin 250mg', category: 'Antibiotic', price: 12.50, stock: 200, unit: 'capsules', manufacturer: 'MediGen', expiry: '2025-12-31', status: 'in-stock', prescriptionRequired: true },
  { id: 3, name: 'Metformin 500mg', category: 'Antidiabetic', price: 8.75, stock: 15, unit: 'tablets', manufacturer: 'DiabCare', expiry: '2026-03-15', status: 'low-stock', prescriptionRequired: true },
  { id: 4, name: 'Atorvastatin 10mg', category: 'Statin', price: 18.00, stock: 0, unit: 'tablets', manufacturer: 'CardioMed', expiry: '2025-09-30', status: 'out-of-stock', prescriptionRequired: true },
  { id: 5, name: 'Omeprazole 20mg', category: 'PPI', price: 9.25, stock: 350, unit: 'capsules', manufacturer: 'GastroPharm', expiry: '2026-01-20', status: 'in-stock', prescriptionRequired: false },
];

export const mockOrders = [
  {
    id: 'ORD-001', patientId: 1, patient: 'John Smith', status: 'delivered', date: '2024-12-10', address: '123 Main St, NY', deliveryDate: '2024-12-13',
    deliveryBoyId: 1, deliveryBoyName: 'Ravi Kumar', deliveryCharge: 5.00, estimatedDeliveryTime: '2 hrs',
    lineItems: [
      { medicineId: 1, name: 'Paracetamol 500mg', qty: 2, price: 5.99 },
      { medicineId: 5, name: 'Omeprazole 20mg', qty: 1, price: 9.25 },
    ],
    total: 21.23,
    prescriptionVerification: { required: false, status: null, image: null, imageType: null, note: '' },
    statusHistory: [
      { status: 'placed',           updatedBy: 'System',    note: 'Order placed by patient',          timestamp: '2024-12-10T09:00:00Z' },
      { status: 'approved',         updatedBy: 'Admin',     note: 'Order verified and approved',       timestamp: '2024-12-10T10:30:00Z' },
      { status: 'assigned',         updatedBy: 'Admin',     note: 'Assigned to Ravi Kumar',            timestamp: '2024-12-10T11:00:00Z' },
      { status: 'out-for-delivery', updatedBy: 'Ravi Kumar',note: 'Picked up, en route',               timestamp: '2024-12-13T08:00:00Z' },
      { status: 'delivered',        updatedBy: 'Ravi Kumar',note: 'Delivered successfully',            timestamp: '2024-12-13T10:15:00Z' },
    ],
  },
  {
    id: 'ORD-002', patientId: 2, patient: 'Emma Wilson', status: 'out-for-delivery', date: '2024-12-18', address: '456 Oak Ave, CA', deliveryDate: null,
    deliveryBoyId: 2, deliveryBoyName: 'Suresh Patel', deliveryCharge: 4.00, estimatedDeliveryTime: '1 hr',
    lineItems: [
      { medicineId: 2, name: 'Amoxicillin 250mg', qty: 1, price: 12.50 },
    ],
    total: 12.50,
    prescriptionVerification: { required: true, status: 'verified', image: 'prescription_emma_ord002.jpg', imageType: 'image', note: 'Prescription verified by admin' },
    statusHistory: [
      { status: 'placed',           updatedBy: 'System',      note: 'Order placed by patient',    timestamp: '2024-12-18T08:00:00Z' },
      { status: 'approved',         updatedBy: 'Admin',       note: 'Approved',                   timestamp: '2024-12-18T09:00:00Z' },
      { status: 'assigned',         updatedBy: 'Admin',       note: 'Assigned to Suresh Patel',   timestamp: '2024-12-18T09:30:00Z' },
      { status: 'out-for-delivery', updatedBy: 'Suresh Patel',note: 'Out for delivery',           timestamp: '2024-12-18T10:00:00Z' },
    ],
  },
  {
    id: 'ORD-003', patientId: 4, patient: 'Olivia Taylor', status: 'approved', date: '2024-12-19', address: '789 Pine Rd, TX', deliveryDate: null,
    deliveryBoyId: null, deliveryBoyName: null, deliveryCharge: 0, estimatedDeliveryTime: null,
    lineItems: [
      { medicineId: 3, name: 'Metformin 500mg', qty: 3, price: 8.75 },
    ],
    total: 26.25,
    prescriptionVerification: { required: true, status: 'verified', image: 'prescription_olivia_ord003.pdf', imageType: 'pdf', note: 'Valid prescription uploaded' },
    statusHistory: [
      { status: 'placed',   updatedBy: 'System', note: 'Order placed by patient', timestamp: '2024-12-19T07:00:00Z' },
      { status: 'approved', updatedBy: 'Admin',  note: 'Approved',                timestamp: '2024-12-19T08:00:00Z' },
    ],
  },
  {
    id: 'ORD-004', patientId: 5, patient: 'William Anderson', status: 'placed', date: '2024-12-20', address: '321 Elm St, FL', deliveryDate: null,
    deliveryBoyId: null, deliveryBoyName: null, deliveryCharge: 0, estimatedDeliveryTime: null,
    lineItems: [
      { medicineId: 4, name: 'Atorvastatin 10mg', qty: 2, price: 18.00 },
      { medicineId: 1, name: 'Paracetamol 500mg', qty: 1, price: 5.99 },
    ],
    total: 41.99,
    prescriptionVerification: { required: true, status: 'pending', image: 'prescription_william_ord004.jpg', imageType: 'image', note: '' },
    statusHistory: [
      { status: 'placed', updatedBy: 'System', note: 'Order placed by patient', timestamp: '2024-12-20T06:00:00Z' },
    ],
  },
  {
    id: 'ORD-005', patientId: 3, patient: 'James Brown', status: 'cancelled', date: '2024-12-20', address: '654 Maple Dr, WA', deliveryDate: null,
    deliveryBoyId: null, deliveryBoyName: null, deliveryCharge: 0, estimatedDeliveryTime: null,
    lineItems: [
      { medicineId: 5, name: 'Omeprazole 20mg', qty: 2, price: 9.25 },
    ],
    total: 18.50,
    prescriptionVerification: { required: false, status: null, image: null, imageType: null, note: '' },
    statusHistory: [
      { status: 'placed',    updatedBy: 'System', note: 'Order placed by patient', timestamp: '2024-12-20T07:00:00Z' },
      { status: 'cancelled', updatedBy: 'Admin',  note: 'Cancelled by admin',      timestamp: '2024-12-20T08:00:00Z' },
    ],
  },
];

export const mockPayments = [
  { id: 'TXN-001', patient: 'John Smith', doctor: 'Dr. Sarah Johnson', type: 'Appointment', amount: 150, doctorFee: 150, commission: 15, doctorEarning: 135, platformEarning: 15, status: 'completed', date: '2024-12-10', method: 'Credit Card', reference: 'REF-ABC123' },
  { id: 'TXN-002', patient: 'Emma Wilson', doctor: null, type: 'Medicine Order', amount: 12.50, doctorFee: null, commission: null, doctorEarning: null, platformEarning: null, status: 'completed', date: '2024-12-18', method: 'PayPal', reference: 'REF-DEF456' },
  { id: 'TXN-003', patient: 'James Brown', doctor: 'Dr. Michael Chen', type: 'Appointment', amount: 120, doctorFee: 120, commission: 20, doctorEarning: 100, platformEarning: 20, status: 'refunded', date: '2024-12-19', method: 'Debit Card', reference: 'REF-GHI789' },
  { id: 'TXN-004', patient: 'Olivia Taylor', doctor: null, type: 'Medicine Order', amount: 26.25, doctorFee: null, commission: null, doctorEarning: null, platformEarning: null, status: 'pending', date: '2024-12-19', method: 'UPI', reference: 'REF-JKL012' },
  { id: 'TXN-005', patient: 'William Anderson', doctor: 'Dr. Emily Davis', type: 'Appointment', amount: 100, doctorFee: 100, commission: 8, doctorEarning: 92, platformEarning: 8, status: 'failed', date: '2024-12-20', method: 'Credit Card', reference: 'REF-MNO345' },
];

export const mockSpecializations = [
  { id: 1, name: 'Cardiologist',      status: 'active',   createdAt: '2024-01-10', doctorCount: 3 },
  { id: 2, name: 'Neurologist',       status: 'active',   createdAt: '2024-01-12', doctorCount: 2 },
  { id: 3, name: 'Pediatrician',      status: 'active',   createdAt: '2024-01-15', doctorCount: 4 },
  { id: 4, name: 'Orthopedic',        status: 'active',   createdAt: '2024-02-01', doctorCount: 2 },
  { id: 5, name: 'Dermatologist',     status: 'active',   createdAt: '2024-02-05', doctorCount: 1 },
  { id: 6, name: 'General Physician', status: 'active',   createdAt: '2024-02-10', doctorCount: 5 },
  { id: 7, name: 'Psychiatrist',      status: 'inactive', createdAt: '2024-03-01', doctorCount: 0 },
  { id: 8, name: 'Oncologist',        status: 'active',   createdAt: '2024-03-05', doctorCount: 1 },
  { id: 9, name: 'Radiologist',       status: 'inactive', createdAt: '2024-03-10', doctorCount: 0 },
  { id: 10, name: 'Endocrinologist',  status: 'active',   createdAt: '2024-04-01', doctorCount: 1 },
];

export const mockTimeSlots = [
  { id: 1,  startTime: '08:00', endTime: '09:00', label: '08:00 AM - 09:00 AM', period: 'morning', status: 'active',   doctorCount: 2 },
  { id: 2,  startTime: '09:00', endTime: '10:00', label: '09:00 AM - 10:00 AM', period: 'morning', status: 'active',   doctorCount: 4 },
  { id: 3,  startTime: '10:00', endTime: '11:00', label: '10:00 AM - 11:00 AM', period: 'morning', status: 'active',   doctorCount: 3 },
  { id: 4,  startTime: '11:00', endTime: '12:00', label: '11:00 AM - 12:00 PM', period: 'morning', status: 'active',   doctorCount: 2 },
  { id: 5,  startTime: '12:00', endTime: '13:00', label: '12:00 PM - 01:00 PM', period: 'afternoon', status: 'inactive', doctorCount: 0 },
  { id: 6,  startTime: '13:00', endTime: '14:00', label: '01:00 PM - 02:00 PM', period: 'afternoon', status: 'active',   doctorCount: 3 },
  { id: 7,  startTime: '14:00', endTime: '15:00', label: '02:00 PM - 03:00 PM', period: 'afternoon', status: 'active',   doctorCount: 4 },
  { id: 8,  startTime: '15:00', endTime: '16:00', label: '03:00 PM - 04:00 PM', period: 'afternoon', status: 'active',   doctorCount: 2 },
  { id: 9,  startTime: '16:00', endTime: '17:00', label: '04:00 PM - 05:00 PM', period: 'evening',   status: 'active',   doctorCount: 1 },
  { id: 10, startTime: '17:00', endTime: '18:00', label: '05:00 PM - 06:00 PM', period: 'evening',   status: 'inactive', doctorCount: 0 },
  { id: 11, startTime: '18:00', endTime: '19:00', label: '06:00 PM - 07:00 PM', period: 'evening',   status: 'active',   doctorCount: 1 },
];

export const mockLabTestCategories = [
  { id: 1, name: 'Blood Test',      icon: 'droplet',   status: 'active',   testCount: 4, description: 'Tests involving blood samples',
    sampleMappings: [{ sampleType: 'Blood', quantity: 5, unit: 'ml' }] },
  { id: 2, name: 'Urine Test',      icon: 'flask',     status: 'active',   testCount: 2, description: 'Tests involving urine samples',
    sampleMappings: [{ sampleType: 'Urine', quantity: 10, unit: 'ml' }] },
  { id: 3, name: 'Imaging',         icon: 'scan',      status: 'active',   testCount: 3, description: 'X-Ray, MRI, CT Scan, Ultrasound',
    sampleMappings: [{ sampleType: 'Imaging', quantity: 1, unit: 'session' }] },
  { id: 4, name: 'Hormone Test',    icon: 'activity',  status: 'active',   testCount: 2, description: 'Thyroid, cortisol, insulin panels',
    sampleMappings: [{ sampleType: 'Blood', quantity: 3, unit: 'ml' }] },
  { id: 5, name: 'Diabetes Panel',  icon: 'heart',     status: 'active',   testCount: 2, description: 'HbA1c, fasting glucose, insulin',
    sampleMappings: [{ sampleType: 'Blood', quantity: 4, unit: 'ml' }] },
  { id: 6, name: 'Cardiac Panel',   icon: 'heart',     status: 'active',   testCount: 1, description: 'Troponin, CK-MB, lipid profile',
    sampleMappings: [{ sampleType: 'Blood', quantity: 6, unit: 'ml' }] },
  { id: 7, name: 'Allergy Test',    icon: 'shield',    status: 'inactive', testCount: 0, description: 'IgE, skin prick, RAST tests',
    sampleMappings: [{ sampleType: 'Blood', quantity: 3, unit: 'ml' }, { sampleType: 'Saliva', quantity: 2, unit: 'ml' }] },
  { id: 8, name: 'Microbiology',    icon: 'microscope',status: 'active',   testCount: 1, description: 'Culture, sensitivity, gram stain',
    sampleMappings: [{ sampleType: 'Blood', quantity: 5, unit: 'ml' }, { sampleType: 'Urine', quantity: 5, unit: 'ml' }] },
];

export const mockLabTests = [
  {
    id: 1, name: 'Complete Blood Count (CBC)', categoryId: 1, category: 'Blood Test',
    description: 'Measures different components of blood including RBC, WBC, platelets, hemoglobin and hematocrit.',
    price: 25.00, sampleType: 'Blood', sampleQuantity: 5, sampleUnit: 'ml',
    fastingRequired: false, reportTime: '24 hrs',
    homeCollection: true, status: 'active', featured: true, discount: 0,
    timeSlots: ['09:00 AM - 10:00 AM', '10:00 AM - 11:00 AM', '02:00 PM - 03:00 PM'],
    packageTests: [], createdAt: '2024-01-10',
  },
  {
    id: 2, name: 'Fasting Blood Sugar (FBS)', categoryId: 5, category: 'Diabetes Panel',
    description: 'Measures blood glucose level after an overnight fast. Used to diagnose diabetes and prediabetes.',
    price: 15.00, sampleType: 'Blood', sampleQuantity: 4, sampleUnit: 'ml',
    fastingRequired: true, reportTime: '4 hrs',
    homeCollection: true, status: 'active', featured: false, discount: 10,
    timeSlots: ['08:00 AM - 09:00 AM', '09:00 AM - 10:00 AM'],
    packageTests: [], createdAt: '2024-01-12',
  },
  {
    id: 3, name: 'Thyroid Panel (TSH, T3, T4)', categoryId: 4, category: 'Hormone Test',
    description: 'Evaluates thyroid gland function by measuring TSH, free T3, and free T4 hormone levels.',
    price: 45.00, sampleType: 'Blood', sampleQuantity: 3, sampleUnit: 'ml',
    fastingRequired: false, reportTime: '48 hrs',
    homeCollection: true, status: 'active', featured: true, discount: 0,
    timeSlots: ['10:00 AM - 11:00 AM', '11:00 AM - 12:00 PM'],
    packageTests: [], createdAt: '2024-01-15',
  },
  {
    id: 4, name: 'Urine Routine & Microscopy', categoryId: 2, category: 'Urine Test',
    description: 'Analyzes physical, chemical, and microscopic properties of urine to detect infections and kidney issues.',
    price: 12.00, sampleType: 'Urine', sampleQuantity: 10, sampleUnit: 'ml',
    fastingRequired: false, reportTime: '6 hrs',
    homeCollection: false, status: 'active', featured: false, discount: 0,
    timeSlots: ['09:00 AM - 10:00 AM', '01:00 PM - 02:00 PM'],
    packageTests: [], createdAt: '2024-02-01',
  },
  {
    id: 5, name: 'Chest X-Ray', categoryId: 3, category: 'Imaging',
    description: 'Produces images of the chest including lungs, heart, and bones to detect pneumonia, fractures, and tumors.',
    price: 35.00, sampleType: 'Imaging', sampleQuantity: 1, sampleUnit: 'session',
    fastingRequired: false, reportTime: '2 hrs',
    homeCollection: false, status: 'active', featured: false, discount: 5,
    timeSlots: ['10:00 AM - 11:00 AM', '02:00 PM - 03:00 PM', '04:00 PM - 05:00 PM'],
    packageTests: [], createdAt: '2024-02-05',
  },
  {
    id: 6, name: 'Lipid Profile', categoryId: 6, category: 'Cardiac Panel',
    description: 'Measures cholesterol levels including LDL, HDL, total cholesterol and triglycerides.',
    price: 30.00, sampleType: 'Blood', sampleQuantity: 6, sampleUnit: 'ml',
    fastingRequired: true, reportTime: '24 hrs',
    homeCollection: true, status: 'active', featured: true, discount: 0,
    timeSlots: ['08:00 AM - 09:00 AM', '09:00 AM - 10:00 AM'],
    packageTests: [], createdAt: '2024-02-10',
  },
  {
    id: 7, name: 'Full Body Checkup', categoryId: 1, category: 'Blood Test',
    description: 'Comprehensive health screening package including CBC, LFT, KFT, lipid profile, thyroid, and blood sugar.',
    price: 120.00, sampleType: 'Blood', sampleQuantity: 5, sampleUnit: 'ml',
    fastingRequired: true, reportTime: '48 hrs',
    homeCollection: true, status: 'active', featured: true, discount: 20,
    timeSlots: ['08:00 AM - 09:00 AM', '09:00 AM - 10:00 AM'],
    packageTests: [1, 2, 3, 6], createdAt: '2024-03-01',
  },
  {
    id: 8, name: 'MRI Brain', categoryId: 3, category: 'Imaging',
    description: 'Detailed imaging of brain structures using magnetic resonance. Used for neurological conditions.',
    price: 180.00, sampleType: 'Imaging', sampleQuantity: 1, sampleUnit: 'session',
    fastingRequired: false, reportTime: '3 days',
    homeCollection: false, status: 'inactive', featured: false, discount: 0,
    timeSlots: ['10:00 AM - 11:00 AM', '02:00 PM - 03:00 PM'],
    packageTests: [], createdAt: '2024-03-10',
  },
];

export const mockDeliveryBoys = [
  {
    id: 1, name: 'Ravi Kumar', phone: '+1-555-3001', email: 'ravi@medihub.com',
    status: 'active', verified: true, vehicleType: 'Bike',
    walletBalance: 240.50, totalEarnings: 860.50, totalWithdrawn: 600.00,
    totalDeliveries: 128, completedDeliveries: 120,
    pendingDeliveries: 5, cancelledDeliveries: 3,
    joinDate: '2024-01-20', idProof: 'aadhar_ravi.pdf',
    assignedOrders: ['ORD-001', 'ORD-003'],
    withdrawRequests: [
      { id: 'WR-D001', amount: 300, status: 'pending', date: '2024-12-05', processedDate: '2024-12-06' },
      { id: 'WR-D002', amount: 400, status: 'rejected', date: '2024-10-20', processedDate: '2024-10-25' },
      { id: 'WR-D003', amount: 100, status: 'approved', date: '2025-11-20', processedDate: '2025-11-21' },
    ],
    walletTransactions: [
      { id: 1, type: 'credit', orderId: 'ORD-001', amount: 50, description: 'Delivery charge for ORD-001', date: '2024-12-18' },
      { id: 2, type: 'debit',  orderId: null,      amount: 20, description: 'Withdrawal',                  date: '2024-12-15' },
      { id: 3, type: 'credit', orderId: 'ORD-003', amount: 30, description: 'Delivery charge for ORD-003', date: '2024-12-10' },
    ],
  },
  {
    id: 2, name: 'Suresh Patel', phone: '+1-555-3002', email: 'suresh@medihub.com',
    status: 'active', verified: true, vehicleType: 'Scooter',
    walletBalance: 185.00, totalEarnings: 385.00, totalWithdrawn: 200.00,
    totalDeliveries: 95, completedDeliveries: 88,
    pendingDeliveries: 4, cancelledDeliveries: 3,
    joinDate: '2024-02-10', idProof: 'license_suresh.pdf',
    assignedOrders: ['ORD-002'],
    withdrawRequests: [
      { id: 'WR-D003', amount: 200, status: 'approved', date: '2024-12-01', processedDate: '2024-12-02' },
      { id: 'WR-D004', amount: 150, status: 'pending',  date: '2024-12-19', processedDate: null },
    ],
    walletTransactions: [
      { id: 1, type: 'credit', orderId: 'ORD-002', amount: 40, description: 'Delivery charge for ORD-002', date: '2024-12-17' },
      { id: 2, type: 'debit',  orderId: null,      amount: 15, description: 'Withdrawal',                  date: '2024-12-12' },
    ],
  },
  {
    id: 3, name: 'Amit Singh', phone: '+1-555-3003', email: 'amit@medihub.com',
    status: 'inactive', verified: false, vehicleType: 'Bicycle',
    walletBalance: 60.00, totalEarnings: 60.00, totalWithdrawn: 0,
    totalDeliveries: 32, completedDeliveries: 28,
    pendingDeliveries: 2, cancelledDeliveries: 2,
    joinDate: '2024-04-05', idProof: null,
    assignedOrders: [],
    withdrawRequests: [],
    walletTransactions: [
      { id: 1, type: 'credit', orderId: null, amount: 20, description: 'Delivery payout', date: '2024-11-30' },
    ],
  },
  {
    id: 4, name: 'Deepak Yadav', phone: '+1-555-3004', email: 'deepak@medihub.com',
    status: 'active', verified: true, vehicleType: 'Bike',
    walletBalance: 310.75, totalEarnings: 1110.75, totalWithdrawn: 800.00,
    totalDeliveries: 210, completedDeliveries: 198,
    pendingDeliveries: 8, cancelledDeliveries: 4,
    joinDate: '2023-11-15', idProof: 'passport_deepak.pdf',
    assignedOrders: ['ORD-004', 'ORD-005'],
    withdrawRequests: [
      { id: 'WR-D005', amount: 400, status: 'approved', date: '2024-11-30', processedDate: '2024-12-01' },
      { id: 'WR-D006', amount: 400, status: 'approved', date: '2024-12-10', processedDate: '2024-12-11' },
      { id: 'WR-D007', amount: 200, status: 'pending',  date: '2024-12-20', processedDate: null },
    ],
    walletTransactions: [
      { id: 1, type: 'credit', orderId: 'ORD-004', amount: 80, description: 'Delivery charge for ORD-004', date: '2024-12-19' },
      { id: 2, type: 'debit',  orderId: null,      amount: 50, description: 'Withdrawal',                  date: '2024-12-14' },
      { id: 3, type: 'credit', orderId: 'ORD-005', amount: 60, description: 'Delivery charge for ORD-005', date: '2024-12-08' },
    ],
  },
  {
    id: 5, name: 'Priya Sharma', phone: '+1-555-3005', email: 'priya@medihub.com',
    status: 'active', verified: false, vehicleType: 'Scooter',
    walletBalance: 95.25, totalEarnings: 95.25, totalWithdrawn: 0,
    totalDeliveries: 47, completedDeliveries: 43,
    pendingDeliveries: 3, cancelledDeliveries: 1,
    joinDate: '2024-06-01', idProof: 'aadhar_priya.pdf',
    assignedOrders: [],
    withdrawRequests: [],
    walletTransactions: [
      { id: 1, type: 'credit', orderId: null, amount: 35, description: 'Delivery payout', date: '2024-12-16' },
    ],
  },
];

export const mockDepositRequests = [
  {
    id: 'DEP-001', patientId: 1, patientName: 'John Smith', patientEmail: 'john@email.com', patientPhone: '+1-555-1001',
    amount: 200, method: 'UPI', reference: 'UPI-REF-001', proofFile: 'receipt_john_001.jpg', proofType: 'image',
    status: 'pending', date: '2024-12-18', notes: 'Recharge for upcoming appointments',
    adminNote: '', processedDate: null,
  },
  {
    id: 'DEP-002', patientId: 2, patientName: 'Emma Wilson', patientEmail: 'emma@email.com', patientPhone: '+1-555-1002',
    amount: 500, method: 'Bank Transfer', reference: 'NEFT-EMM-002', proofFile: 'bank_slip_emma.pdf', proofType: 'pdf',
    status: 'approved', date: '2024-12-15', notes: 'Monthly wallet top-up',
    adminNote: 'Verified via bank statement', processedDate: '2024-12-15',
  },
  {
    id: 'DEP-003', patientId: 3, patientName: 'James Brown', patientEmail: 'james@email.com', patientPhone: '+1-555-1003',
    amount: 150, method: 'Credit Card', reference: 'CC-JAM-003', proofFile: null, proofType: null,
    status: 'rejected', date: '2024-12-10', notes: '',
    adminNote: 'Reference ID mismatch', processedDate: '2024-12-11',
  },
  {
    id: 'DEP-004', patientId: 4, patientName: 'Olivia Taylor', patientEmail: 'olivia@email.com', patientPhone: '+1-555-1004',
    amount: 300, method: 'PayPal', reference: 'PP-OLI-004', proofFile: 'paypal_olivia.jpg', proofType: 'image',
    status: 'pending', date: '2024-12-20', notes: 'For medicine orders',
    adminNote: '', processedDate: null,
  },
  {
    id: 'DEP-005', patientId: 5, patientName: 'William Anderson', patientEmail: 'william@email.com', patientPhone: '+1-555-1005',
    amount: 1000, method: 'Bank Transfer', reference: 'NEFT-WIL-005', proofFile: 'bank_slip_william.pdf', proofType: 'pdf',
    status: 'approved', date: '2024-12-08', notes: 'Annual wallet recharge',
    adminNote: 'Approved after verification', processedDate: '2024-12-09',
  },
  {
    id: 'DEP-006', patientId: 1, patientName: 'John Smith', patientEmail: 'john@email.com', patientPhone: '+1-555-1001',
    amount: 100, method: 'UPI', reference: 'UPI-REF-006', proofFile: 'upi_john_006.jpg', proofType: 'image',
    status: 'pending', date: '2024-12-21', notes: '',
    adminNote: '', processedDate: null,
  },
];

/* ── Lab Bookings ──────────────────────────────────────────────────────────── */
// Status lifecycle order (used for validation)
export const LAB_BOOKING_STATUSES = [
  'booked',
  'sample_collection_scheduled',
  'sample_collected',
  'testing_in_progress',
  'report_ready',
  'completed',
  'cancelled',
];

export const mockLabBookings = [
  {
    id: 'LB-001',
    patientId: 1,
    patientName: 'John Smith',
    patientPhone: '+1-555-1001',
    patientEmail: 'john@email.com',
    testId: 1,
    testName: 'Complete Blood Count (CBC)',
    category: 'Blood Test',
    sampleType: 'Blood',
    sampleQuantity: 5,
    sampleUnit: 'ml',
    collectionType: 'home',
    preferredDate: '2024-12-22',
    preferredTime: '09:00 AM - 10:00 AM',
    status: 'sample_collected',
    amount: 25.00,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    labPartner: 'MediLab Diagnostics',
    collection: {
      scheduledDate: '2024-12-22',
      scheduledTime: '09:00 AM',
      agentId: 1,
      agentName: 'Ravi Kumar',
      notes: 'Patient requested morning slot',
      collectedAt: '2024-12-22T09:15:00Z',
    },
    report: null,
    statusHistory: [
      { status: 'booked',                       updatedBy: 'System', note: 'Booking confirmed',                    timestamp: '2024-12-20T10:00:00Z' },
      { status: 'sample_collection_scheduled',  updatedBy: 'Admin',  note: 'Agent Ravi Kumar assigned',           timestamp: '2024-12-21T09:00:00Z' },
      { status: 'sample_collected',             updatedBy: 'Admin',  note: 'Sample collected successfully',       timestamp: '2024-12-22T09:20:00Z' },
    ],
    createdAt: '2024-12-20T10:00:00Z',
  },
  {
    id: 'LB-002',
    patientId: 2,
    patientName: 'Emma Wilson',
    patientPhone: '+1-555-1002',
    patientEmail: 'emma@email.com',
    testId: 3,
    testName: 'Thyroid Panel (TSH, T3, T4)',
    category: 'Hormone Test',
    sampleType: 'Blood',
    sampleQuantity: 3,
    sampleUnit: 'ml',
    collectionType: 'home',
    preferredDate: '2024-12-23',
    preferredTime: '10:00 AM - 11:00 AM',
    status: 'testing_in_progress',
    amount: 45.00,
    paymentStatus: 'completed',
    paymentMethod: 'UPI',
    labPartner: 'CityPath Labs',
    collection: {
      scheduledDate: '2024-12-23',
      scheduledTime: '10:00 AM',
      agentId: 2,
      agentName: 'Suresh Patel',
      notes: '',
      collectedAt: '2024-12-23T10:05:00Z',
    },
    report: null,
    statusHistory: [
      { status: 'booked',                       updatedBy: 'System', note: 'Booking confirmed',              timestamp: '2024-12-21T11:00:00Z' },
      { status: 'sample_collection_scheduled',  updatedBy: 'Admin',  note: 'Agent Suresh Patel assigned',   timestamp: '2024-12-22T08:00:00Z' },
      { status: 'sample_collected',             updatedBy: 'Admin',  note: 'Sample collected',              timestamp: '2024-12-23T10:10:00Z' },
      { status: 'testing_in_progress',          updatedBy: 'Admin',  note: 'Sample sent to CityPath Labs', timestamp: '2024-12-23T12:00:00Z' },
    ],
    createdAt: '2024-12-21T11:00:00Z',
  },
  {
    id: 'LB-003',
    patientId: 3,
    patientName: 'James Brown',
    patientPhone: '+1-555-1003',
    patientEmail: 'james@email.com',
    testId: 7,
    testName: 'Full Body Checkup',
    category: 'Blood Test',
    sampleType: 'Blood',
    sampleQuantity: 5,
    sampleUnit: 'ml',
    collectionType: 'lab',
    preferredDate: '2024-12-24',
    preferredTime: '08:00 AM - 09:00 AM',
    status: 'report_ready',
    amount: 96.00,
    paymentStatus: 'completed',
    paymentMethod: 'Debit Card',
    labPartner: 'MediLab Diagnostics',
    collection: {
      scheduledDate: '2024-12-24',
      scheduledTime: '08:00 AM',
      agentId: null,
      agentName: null,
      notes: 'Patient will visit lab directly',
      collectedAt: '2024-12-24T08:10:00Z',
    },
    report: {
      fileName: 'full_body_james_LB003.pdf',
      fileType: 'pdf',
      uploadedAt: '2024-12-25T14:00:00Z',
      uploadedBy: 'Admin',
    },
    statusHistory: [
      { status: 'booked',                       updatedBy: 'System', note: 'Booking confirmed',          timestamp: '2024-12-22T09:00:00Z' },
      { status: 'sample_collection_scheduled',  updatedBy: 'Admin',  note: 'Lab visit scheduled',        timestamp: '2024-12-22T10:00:00Z' },
      { status: 'sample_collected',             updatedBy: 'Admin',  note: 'Sample collected at lab',    timestamp: '2024-12-24T08:15:00Z' },
      { status: 'testing_in_progress',          updatedBy: 'Admin',  note: 'Testing started',            timestamp: '2024-12-24T09:00:00Z' },
      { status: 'report_ready',                 updatedBy: 'Admin',  note: 'Report uploaded',            timestamp: '2024-12-25T14:05:00Z' },
    ],
    createdAt: '2024-12-22T09:00:00Z',
  },
  {
    id: 'LB-004',
    patientId: 4,
    patientName: 'Olivia Taylor',
    patientPhone: '+1-555-1004',
    patientEmail: 'olivia@email.com',
    testId: 2,
    testName: 'Fasting Blood Sugar (FBS)',
    category: 'Diabetes Panel',
    sampleType: 'Blood',
    sampleQuantity: 4,
    sampleUnit: 'ml',
    collectionType: 'home',
    preferredDate: '2024-12-25',
    preferredTime: '08:00 AM - 09:00 AM',
    status: 'booked',
    amount: 13.50,
    paymentStatus: 'completed',
    paymentMethod: 'PayPal',
    labPartner: null,
    collection: {
      scheduledDate: null,
      scheduledTime: null,
      agentId: null,
      agentName: null,
      notes: '',
      collectedAt: null,
    },
    report: null,
    statusHistory: [
      { status: 'booked', updatedBy: 'System', note: 'Booking confirmed', timestamp: '2024-12-23T15:00:00Z' },
    ],
    createdAt: '2024-12-23T15:00:00Z',
  },
  {
    id: 'LB-005',
    patientId: 5,
    patientName: 'William Anderson',
    patientPhone: '+1-555-1005',
    patientEmail: 'william@email.com',
    testId: 6,
    testName: 'Lipid Profile',
    category: 'Cardiac Panel',
    sampleType: 'Blood',
    sampleQuantity: 6,
    sampleUnit: 'ml',
    collectionType: 'lab',
    preferredDate: '2024-12-18',
    preferredTime: '09:00 AM - 10:00 AM',
    status: 'completed',
    amount: 30.00,
    paymentStatus: 'completed',
    paymentMethod: 'Credit Card',
    labPartner: 'HealthFirst Labs',
    collection: {
      scheduledDate: '2024-12-18',
      scheduledTime: '09:00 AM',
      agentId: null,
      agentName: null,
      notes: 'Fasting confirmed by patient',
      collectedAt: '2024-12-18T09:05:00Z',
    },
    report: {
      fileName: 'lipid_profile_william_LB005.pdf',
      fileType: 'pdf',
      uploadedAt: '2024-12-19T10:00:00Z',
      uploadedBy: 'Admin',
    },
    statusHistory: [
      { status: 'booked',                       updatedBy: 'System', note: 'Booking confirmed',       timestamp: '2024-12-16T08:00:00Z' },
      { status: 'sample_collection_scheduled',  updatedBy: 'Admin',  note: 'Lab visit scheduled',     timestamp: '2024-12-16T09:00:00Z' },
      { status: 'sample_collected',             updatedBy: 'Admin',  note: 'Sample collected at lab', timestamp: '2024-12-18T09:10:00Z' },
      { status: 'testing_in_progress',          updatedBy: 'Admin',  note: 'Testing in progress',     timestamp: '2024-12-18T10:00:00Z' },
      { status: 'report_ready',                 updatedBy: 'Admin',  note: 'Report uploaded',         timestamp: '2024-12-19T10:05:00Z' },
      { status: 'completed',                    updatedBy: 'Admin',  note: 'Booking completed',       timestamp: '2024-12-19T11:00:00Z' },
    ],
    createdAt: '2024-12-16T08:00:00Z',
  },
  {
    id: 'LB-006',
    patientId: 1,
    patientName: 'John Smith',
    patientPhone: '+1-555-1001',
    patientEmail: 'john@email.com',
    testId: 4,
    testName: 'Urine Routine & Microscopy',
    category: 'Urine Test',
    sampleType: 'Urine',
    sampleQuantity: 10,
    sampleUnit: 'ml',
    collectionType: 'lab',
    preferredDate: '2024-12-21',
    preferredTime: '01:00 PM - 02:00 PM',
    status: 'cancelled',
    amount: 12.00,
    paymentStatus: 'refunded',
    paymentMethod: 'UPI',
    labPartner: null,
    collection: {
      scheduledDate: null,
      scheduledTime: null,
      agentId: null,
      agentName: null,
      notes: '',
      collectedAt: null,
    },
    report: null,
    statusHistory: [
      { status: 'booked',     updatedBy: 'System', note: 'Booking confirmed',          timestamp: '2024-12-20T14:00:00Z' },
      { status: 'cancelled',  updatedBy: 'Admin',  note: 'Cancelled by patient request', timestamp: '2024-12-20T16:00:00Z' },
    ],
    createdAt: '2024-12-20T14:00:00Z',
  },
  {
    id: 'LB-007',
    patientId: 2,
    patientName: 'Emma Wilson',
    patientPhone: '+1-555-1002',
    patientEmail: 'emma@email.com',
    testId: 5,
    testName: 'Chest X-Ray',
    category: 'Imaging',
    sampleType: 'Imaging',
    sampleQuantity: 1,
    sampleUnit: 'session',
    collectionType: 'lab',
    preferredDate: '2024-12-26',
    preferredTime: '10:00 AM - 11:00 AM',
    status: 'sample_collection_scheduled',
    amount: 33.25,
    paymentStatus: 'pending',
    paymentMethod: 'Debit Card',
    labPartner: 'CityPath Labs',
    collection: {
      scheduledDate: '2024-12-26',
      scheduledTime: '10:00 AM',
      agentId: null,
      agentName: null,
      notes: 'Patient to visit imaging centre',
      collectedAt: null,
    },
    report: null,
    statusHistory: [
      { status: 'booked',                       updatedBy: 'System', note: 'Booking confirmed',      timestamp: '2024-12-24T10:00:00Z' },
      { status: 'sample_collection_scheduled',  updatedBy: 'Admin',  note: 'Lab visit scheduled',    timestamp: '2024-12-24T11:00:00Z' },
    ],
    createdAt: '2024-12-24T10:00:00Z',
  },
];

/* ── Support Tickets ───────────────────────────────────────────────────────── */
export const mockSupportTickets = [
  {
    id: 'TKT-001', userId: 1, userName: 'John Smith', userType: 'Patient',
    userEmail: 'john@email.com', userPhone: '+1-555-1001',
    title: 'Unable to book appointment', priority: 'high', status: 'open',
    description: 'I am trying to book an appointment with Dr. Sarah Johnson but the booking button is not responding. I have tried multiple times on different browsers.',
    image: 'screenshot_booking_error.png', imageType: 'image',
    assignedTo: null, createdAt: '2024-12-20T10:00:00Z', updatedAt: '2024-12-20T10:00:00Z',
    notes: [],
  },
  {
    id: 'TKT-002', userId: 1, userName: 'Dr. Michael Chen', userType: 'Doctor',
    userEmail: 'michael@medihub.com', userPhone: '+1-555-0102',
    title: 'Wallet balance not updated', priority: 'medium', status: 'in_progress',
    description: 'My wallet balance has not been updated after completing 3 appointments yesterday. The earnings are showing in history but wallet balance remains the same.',
    image: null, imageType: null,
    assignedTo: 'Admin', createdAt: '2024-12-19T14:00:00Z', updatedAt: '2024-12-20T09:00:00Z',
    notes: [
      { id: 1, text: 'Investigating the wallet sync issue. Will update shortly.', addedBy: 'Admin', timestamp: '2024-12-20T09:00:00Z' },
    ],
  },
  {
    id: 'TKT-003', userId: 1, userName: 'Ravi Kumar', userType: 'Delivery',
    userEmail: 'ravi@medihub.com', userPhone: '+1-555-3001',
    title: 'Order not showing in my list', priority: 'low', status: 'resolved',
    description: 'Order ORD-003 was assigned to me but it is not showing in my assigned orders list. I cannot proceed with the delivery.',
    image: 'order_missing_ravi.jpg', imageType: 'image',
    assignedTo: 'Admin', createdAt: '2024-12-18T08:00:00Z', updatedAt: '2024-12-18T12:00:00Z',
    notes: [
      { id: 1, text: 'Checked the assignment. Order was re-assigned due to a system glitch. Fixed now.', addedBy: 'Admin', timestamp: '2024-12-18T11:00:00Z' },
      { id: 2, text: 'Confirmed with delivery boy. Issue resolved.', addedBy: 'Admin', timestamp: '2024-12-18T12:00:00Z' },
    ],
  },
  {
    id: 'TKT-004', userId: 2, userName: 'Emma Wilson', userType: 'Patient',
    userEmail: 'emma@email.com', userPhone: '+1-555-1002',
    title: 'Lab report not accessible', priority: 'high', status: 'open',
    description: 'My lab report for booking LB-002 shows as uploaded but when I click download nothing happens. Please help.',
    image: null, imageType: null,
    assignedTo: null, createdAt: '2024-12-21T09:00:00Z', updatedAt: '2024-12-21T09:00:00Z',
    notes: [],
  },
  {
    id: 'TKT-005', userId: 3, userName: 'James Brown', userType: 'Patient',
    userEmail: 'james@email.com', userPhone: '+1-555-1003',
    title: 'Refund not received', priority: 'high', status: 'in_progress',
    description: 'My appointment was cancelled 5 days ago and I was told the refund would be processed in 3 days. I still have not received it.',
    image: 'refund_screenshot.png', imageType: 'image',
    assignedTo: 'Support Agent', createdAt: '2024-12-17T11:00:00Z', updatedAt: '2024-12-20T15:00:00Z',
    notes: [
      { id: 1, text: 'Refund request raised with payment team. ETA 2 business days.', addedBy: 'Admin', timestamp: '2024-12-20T15:00:00Z' },
    ],
  },
  {
    id: 'TKT-006', userId: 2, userName: 'Dr. Emily Davis', userType: 'Doctor',
    userEmail: 'emily@medihub.com', userPhone: '+1-555-0103',
    title: 'Profile verification pending too long', priority: 'medium', status: 'rejected',
    description: 'I submitted my verification documents 2 weeks ago but my profile is still showing as unverified. This is affecting my ability to receive patients.',
    image: 'verification_docs.pdf', imageType: 'pdf',
    assignedTo: 'Admin', createdAt: '2024-12-10T10:00:00Z', updatedAt: '2024-12-15T10:00:00Z',
    notes: [
      { id: 1, text: 'Documents reviewed. Some documents were unclear. Requested re-submission.', addedBy: 'Admin', timestamp: '2024-12-15T10:00:00Z' },
    ],
  },
  {
    id: 'TKT-007', userId: 4, userName: 'Olivia Taylor', userType: 'Patient',
    userEmail: 'olivia@email.com', userPhone: '+1-555-1004',
    title: 'Wrong medicine delivered', priority: 'high', status: 'open',
    description: 'I ordered Metformin 500mg but received Omeprazole 20mg. This is a serious issue as I need my diabetes medication urgently.',
    image: 'wrong_medicine_olivia.jpg', imageType: 'image',
    assignedTo: null, createdAt: '2024-12-21T16:00:00Z', updatedAt: '2024-12-21T16:00:00Z',
    notes: [],
  },
  {
    id: 'TKT-008', userId: 2, userName: 'Suresh Patel', userType: 'Delivery',
    userEmail: 'suresh@medihub.com', userPhone: '+1-555-3002',
    title: 'App crashing during delivery update', priority: 'medium', status: 'resolved',
    description: 'The app crashes every time I try to update the delivery status to out-for-delivery. I have to restart the app multiple times.',
    image: null, imageType: null,
    assignedTo: 'Tech Team', createdAt: '2024-12-16T13:00:00Z', updatedAt: '2024-12-17T10:00:00Z',
    notes: [
      { id: 1, text: 'Bug identified in v2.1.3. Hotfix deployed. Please update the app.', addedBy: 'Tech Team', timestamp: '2024-12-17T10:00:00Z' },
    ],
  },
];

export const dashboardStats = {
  totalPatients: 1248,
  totalDoctors: 86,
  totalAppointments: 3542,
  totalOrders: 892,
  revenue: 124500,
  monthlyData: [
    { month: 'Jul', appointments: 280, revenue: 9800, patients: 95 },
    { month: 'Aug', appointments: 310, revenue: 11200, patients: 108 },
    { month: 'Sep', appointments: 295, revenue: 10500, patients: 102 },
    { month: 'Oct', appointments: 340, revenue: 12800, patients: 125 },
    { month: 'Nov', appointments: 380, revenue: 14200, patients: 138 },
    { month: 'Dec', appointments: 420, revenue: 16500, patients: 152 },
  ],
  appointmentsByStatus: [
    { name: 'Scheduled', value: 45 },
    { name: 'Completed', value: 30 },
    { name: 'Pending', value: 15 },
    { name: 'Cancelled', value: 10 },
  ]
};
